'use strict';

require('../../style/index.css');

require('./index.css');


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/input-number/style/css.js
// module id = 562
// module chunks = 0